import Immutable from 'immutable';
import { configModel } from './app_config_model';

/**
 * The Page Map
 */
export const pageInitialState = Immutable.Map({
    transitioningToNewPage: false, // Flag that gets set to true when a transition to a new page is started, set back to false once the transition has ended
    showPleaseWait: false,
    location: Immutable.Map(),
    name: null,
    title: null,
    vertical: configModel.getAppName(),
    experimentId: null,
    splitTrafficId: null,
    experimentData: null,
    brand: process.env.EVEREST_THEME?.trim(),
    deployEnv: process.env.EVEREST_DEPLOY_ENV?.trim(),
    lastViewedPage: null,
    // The value used to determine redirecting the user back to results on next step click.
    hasSeenResults: false
});

/**
 * These values represent the application breakpoint and we change state values to the object keys
 * e.g. 'xs, sm, md, lg, xl'
 */
export const breakpoints = {
    xs: 767,
    sm: 991,
    md: 1199,
    lg: 1399,
    xl: 1699,
    xxl: 9999
};
